import 'css-chunksrc/client/scenes/taskStatuses/statuses/status/styles.scss';export default {
  "status": "_status_fvkyn_1",
  "trashBox": "_trashBox_fvkyn_10",
  "colorForm": "_colorForm_fvkyn_42",
  "color": "_color_fvkyn_42",
  "colorPicker": "_colorPicker_fvkyn_52",
  "label": "_label_fvkyn_58",
  "completion": "_completion_fvkyn_70",
  "basicCompletion": "_basicCompletion_fvkyn_89",
  "button": "_button_fvkyn_94",
  "icon": "_icon_fvkyn_119"
};